import axios from 'axios';

const runtimeHost = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
const runtimeProtocol = typeof window !== 'undefined' ? window.location.protocol : 'http:';
const runtimePort = typeof window !== 'undefined' ? window.location.port : '';

const defaultBaseUrl = (() => {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }

  // In local development the React app runs on :3001 and the API on :3000.
  if (runtimeHost === 'localhost' || runtimeHost === '127.0.0.1') {
    if (runtimePort === '3001') {
      return `${runtimeProtocol}//${runtimeHost}:3000/api`;
    }
    return `${runtimeProtocol}//${runtimeHost}/api`;
  }

  // In production the app is served behind nginx and API requests should stay on the same origin.
  return '/api';
})();

const API = axios.create({
  baseURL: defaultBaseUrl,
});

// Interceptor um Token an jeden Request zu haengen
API.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});

export default API;
